const shippingMessages = {
  savingShippingPolicy: {
    default: 'Saving shipping policy...',
    translatedKey: 'settings.seller_profile_section.saving_shipping_policy',
  },
  shippingCostTooLowFor: {
    default: (country: string) => `Shipping cost too low for ${country}`,
    translatedKey: 'settings.seller_profile_section.shipping_cost_too_low_for',
  },
  shippingCostTooHighFor: {
    default: (country: string) => `Shipping cost too high for ${country}`,
    translatedKey: 'settings.seller_profile_section.shipping_cost_too_high_for',
  },
  shippingCostTooLowForEurope: {
    default: 'Shipping cost too low for Europe',
    translatedKey:
      'settings.seller_profile_section.shipping_cost_too_low_for_europe',
  },
  shippingCostTooHighForEurope: {
    default: 'Shipping cost too high for Europe',
    translatedKey:
      'settings.seller_profile_section.shipping_cost_too_high_for_europe',
  },
  shippingCostTooLowForDomestic: {
    default: 'Shipping cost too low for domestic',
    translatedKey:
      'settings.seller_profile_section.shipping_cost_too_low_for_domestic',
  },
  shippingCostTooHighForDomestic: {
    default: 'Shipping cost too high for domestic',
    translatedKey:
      'settings.seller_profile_section.shipping_cost_too_high_for_domestic',
  },
  successSavingShippingPolicy: {
    default: 'Success saving shipping policy',
    translatedKey:
      'settings.seller_profile_section.success_saving_shipping_policy',
  },
  errorSavingShippingPolicy: {
    default: 'Error saving shipping policy',
    translatedKey:
      'settings.seller_profile_section.error_saving_shipping_policy',
  },
};

export const userSettingsMessages = {
  savingYourProfile: {
    default: 'Saving your profile...',
    translatedKey: 'settings.saving_your_profile',
  },
  successSavingYourProfile: {
    default: 'Success saving your profile',
    translatedKey: 'settings.success_saving_your_profile',
  },
  errorSavingYourProfile: {
    default: 'Error saving your profile',
    translatedKey: 'settings.error_saving_your_profile',
  },
  yourEmailCannotBeEmpty: {
    default: 'Your email cannot be empty',
    translatedKey: 'settings.your_email_cannot_be_empty',
  },
  yourEmailIsInvalid: {
    default: 'Your email is invalid',
    translatedKey: 'settings.your_email_is_invalid',
  },
  yourFirstNameCannotBeEmpty: {
    default: 'Your name cannot be empty',
    translatedKey: 'settings.your_first_name_cannot_be_empty',
  },
  yourFirstNameIsTooLong: {
    default: 'Your name is too long',
    translatedKey: 'settings.your_first_name_is_too_long',
  },
  yourLastNameCannotBeEmpty: {
    default: 'Your last name cannot be empty',
    translatedKey: 'settings.your_last_name_cannot_be_empty',
  },
  yourLastNameIsInvalid: {
    default: 'Your last name is invalid',
    translatedKey: 'settings.your_last_name_is_invalid',
  },
  yourLastNameIsTooLong: {
    default: 'Your last name is too long',
    translatedKey: 'settings.your_last_name_is_too_long',
  },
  yourPhoneNumberCannotBeEmpty: {
    default: 'Your phone number cannot be empty',
    translatedKey: 'settings.your_phone_number_cannot_be_empty',
  },
  yourPhoneNumberIsInvalid: {
    default: 'Your phone number is invalid',
    translatedKey: 'settings.your_phone_number_is_invalid',
  },
  yourAddressCannotBeEmpty: {
    default: 'Your address cannot be empty',
    translatedKey: 'settings.your_address_cannot_be_empty',
  },
  yourCityCannotBeEmpty: {
    default: 'Your city cannot be empty',
    translatedKey: 'settings.your_city_cannot_be_empty',
  },
  yourCountryCannotBeEmpty: {
    default: 'Your country cannot be empty',
    translatedKey: 'settings.your_country_cannot_be_empty',
  },
  yourPostalCodeCannotBeEmpty: {
    default: 'Your postal code cannot be empty',
    translatedKey: 'settings.your_postal_code_cannot_be_empty',
  },
  yourDateOfBirthCannotBeEmpty: {
    default: 'Your date of birth cannot be empty',
    translatedKey: 'settings.your_date_of_birth_cannot_be_empty',
  },
  yourDateOfBirthIsInvalid: {
    default: 'Your date of birth is invalid',
    translatedKey: 'settings.your_date_of_birth_is_invalid',
  },
  yourLanguageIsInvalid: {
    default: 'Your language is invalid',
    translatedKey: 'settings.your_language_is_invalid',
  },
  yourPostalCodeIsInvalid: {
    default: 'Your postal code for {{country}} is invalid.',
    translatedKey: 'settings.your_postal_code_is_invalid',
  },
};

const modalPortfolioMessages = {
  adding_bottle_to_portfolio: {
    default: 'Adding bottle to portfolio...',
    translatedKey: 'portfolio_modal.adding_bottle_to_portfolio',
  },
  success_adding_bottle_to_portfolio: {
    default: 'Success adding bottle to portfolio',
    translatedKey: 'portfolio_modal.success_adding_bottle_to_portfolio',
  },
  error_adding_bottle_to_portfolio: {
    default: 'Error adding bottle to portfolio',
    translatedKey: 'portfolio_modal.error_adding_bottle_to_portfolio',
  },
};

export const toastMessages = {
  ...shippingMessages,
  ...userSettingsMessages,
  ...modalPortfolioMessages,
  anUnexpectedErrorOccurred: {
    default: 'an_unexpected_error_occurred',
    translatedKey: 'an_unexpected_error_occurred',
  },
  pleaseFillAllRequiredFields: {
    default: 'Please fill all required fields',
    translatedKey: 'please_fill_all_required_fields',
  },
};
